import { Injectable } from '@angular/core';
import { RequestService } from '@df/api/request/request.service';
import { Status } from '@df/core/status';
import { Subject } from 'rxjs';

export interface IFileUploadState {
    progress: number;
    result?: string | ArrayBuffer;
}

@Injectable({
    providedIn: 'root'
})
export class FileLoadService {
    /**
     * Dependencies
     */
    constructor(private requestService: RequestService) {}

    /**
     * Load file
     * Returns observable - events are fired to present progress
     */
    load(status: Status, file: Blob, mode?: 'url') {
        const subject = new Subject<IFileUploadState>();
        this.requestService.send(status, () => {
            if (!file) {
                throw new Error('No file selected');
            }

            const reader = new FileReader();
            reader.addEventListener('load', event => {
                subject.next({ progress: 100, result: event.target.result });
            });
            reader.addEventListener('progress', event => {
                if (event.loaded && event.total) {
                    const progress = Math.round((event.loaded / event.total) * 100);
                    subject.next({ progress });
                }
            });
            if (mode === 'url') {
                reader.readAsDataURL(file);
            } else {
                reader.readAsText(file);
            }
        });

        return subject.asObservable();
    }
}
